import { twMerge } from '@/utils/tw-merge';

export const Divider = ({
  className,
  as,
}: {
  className?: string;
  as?: 'hr' | 'div';
}) => {
  const Component = as === 'hr' ? 'hr' : 'div';

  return (
    <Component
      className={twMerge('border-b border-t-0 border-b-gray-300', className)}
    />
  );
};
